<template>
  <v-row>
    <v-spacer></v-spacer>
    <v-col v-if="!editMode" cols="11" sm="10" md="6" class="font-weight-bold">
      <template v-if="loadingGetUserInfoFinsed">
        <v-row no-gutters class="pa-5">
          <v-col class="primary-1--text" align-self="center">{{
            $t("userinfo_username")
          }}</v-col>
          <v-col class="text-right">{{ userInfo.userName || "-" }}</v-col>
        </v-row>
        <div class="red-dash-divider" />
        <v-row no-gutters class="pa-5">
          <v-col class="primary-1--text" align-self="center">{{
            $t("userinfo_birthday")
          }}</v-col>
          <v-col class="text-right">{{ userInfo.birthday || "-" }}</v-col>
        </v-row>
        <div class="red-dash-divider" />
        <v-row no-gutters class="pa-5">
          <v-col class="primary-1--text" align-self="center">{{
            $t("userinfo_gender")
          }}</v-col>
          <v-col class="text-right">{{ genderText(userInfo.gender) }}</v-col>
        </v-row>
        <div class="red-dash-divider" />
        <v-row no-gutters class="pa-5">
          <v-col class="primary-1--text" align-self="center">{{
            $t("userinfo_phone_number")
          }}</v-col>
          <v-col class="text-right">{{ userInfo.mobile }}</v-col>
        </v-row>
        <div class="red-dash-divider" />
        <v-row no-gutters class="pa-5 pb-2">
          <v-col class="primary-1--text" align-self="center">{{
            $t("userinfo_email")
          }}</v-col>
          <v-col class="text-right"
            >{{ userInfo.email }}
            <v-btn
              outlined
              small
              depressed
              rounded
              color="red red-1"
              class="font-weight-bold red--text"
              prepend-icon="mdi-alert"
              @click="sendVerify"
              v-if="!userInfo.verifyEmail"
            >
              <v-icon color="red accent-red" class="mr-1">mdi-alert</v-icon>
              <span color="red accent-red">{{
                $t("userinfo_email_invalid")
              }}</span>
            </v-btn>
            <div class="font-weight-bold" v-else>
              <v-icon color="#28bd92" size="20">mdi-check-circle</v-icon>
              <span style="color: #28bd92">
                {{ $t("userinfo_email_valid") }}</span
              >
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col>
            <div
              class="v-alert p-4 text-left red--text pink-1 font-weight-regular"
            >
              {{ $t("change_email_note") }}
            </div>
          </v-col>
        </v-row>
        <div class="red-dash-divider" />
        <v-row no-gutters class="pa-5">
          <v-col class="primary-1--text" align-self="center">{{
            $t("userinfo_contact_address")
          }}</v-col>
          <v-col class="text-right"
            >{{ userInfo.county }}{{ userInfo.district
            }}{{ userInfo.address }}</v-col
          >
        </v-row>
        <div class="red-dash-divider" />

        <v-row class="pt-15" no-gutters>
          <v-spacer />
          <v-col cols="8" sm="7">
            <v-btn
              x-large
              outlined
              color="primary-1"
              block
              depressed
              @click="edit"
            >
              {{ $t("userinfo_edit_cta") }}
            </v-btn>
          </v-col>
          <v-spacer />
        </v-row>
      </template>
      <div v-else class="text-center">
        <v-progress-circular
          indeterminate
          color="primary-1"
          size="25"
          width="2"
          class="mx-auto"
        ></v-progress-circular>
      </div>
    </v-col>
    <v-col v-else cols="11" sm="10" md="6" class="text-center">
      <v-form>
        <v-row no-gutters>
          <v-col
            cols="12"
            sm="3"
            md="2"
            :class="$vuetify.breakpoint.xs ? 'pr-2' : 'pr-5'"
          >
            <v-subheader
              ><v-icon
                color="red-2"
                x-small
                :class="{ 'mr-1': !$vuetify.breakpoint.xs }"
                >mdi-asterisk</v-icon
              >{{ $t("userinfo_username") }}</v-subheader
            >
          </v-col>
          <v-col cols="12" sm="9" md="10">
            <v-text-field
              id="userName"
              :label="$t('userinfo_name')"
              v-model="userInfo.userName"
              autocomplete="off"
              outlined
              :error="hasInvalid && !!invalidError.userName"
              :placeholder="$t('username_placeholder')"
              :error-messages="
                hasInvalid && !!invalidError.userName
                  ? [invalidError.userName]
                  : null
              "
              @focus="
                userInfo.userName =
                  userInfo.userName.indexOf('*') === -1 ? userInfo.userName : ''
              "
              @blur="
                userInfo.userName =
                  userInfo.userName === '' ? originUserName : userInfo.userName
              "
              color="primary-1"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-text-field>
            <div
              class="v-alert p-4 text-left red--text pink-1 font-weight-regular"
            >
              {{ $t("username_hint") }}
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col
            cols="12"
            sm="3"
            md="2"
            :class="$vuetify.breakpoint.xs ? 'pr-2' : 'pr-5'"
          >
            <v-subheader>{{ $t("userinfo_birthday") }}</v-subheader>
          </v-col>
          <v-col cols="12" sm="9" md="10">
            <DatePicker
              id="birthday"
              :birthday="userInfo.birthday"
              v-if="loadingGetUserInfoFinsed"
              @updateDate="emitUpdateDate"
            />
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-5">
          <v-col
            cols="12"
            sm="3"
            md="2"
            :class="$vuetify.breakpoint.xs ? 'pr-2' : 'pr-5'"
          >
            <v-subheader>{{ $t("userinfo_gender") }}</v-subheader>
          </v-col>
          <v-col cols="12" sm="9" md="10" align-self="center">
            <v-radio-group
              v-model="userInfo.gender"
              row
              class="ma-0 pa-0 radioBtns"
            >
              <v-radio
                :label="$t('userinfo_male')"
                color="primary"
                value="M"
              ></v-radio>
              <v-radio
                :label="$t('userinfo_female')"
                color="primary"
                value="F"
              ></v-radio>
              <v-radio
                :label="$t('userinfo_other_gender')"
                color="primary"
                value="N"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row no-gutters v-if="!isRegister">
          <v-col
            cols="12"
            sm="3"
            md="2"
            :class="$vuetify.breakpoint.xs ? 'pr-2' : 'pr-5'"
          >
            <v-subheader>{{ $t("userinfo_phone_number") }}</v-subheader>
          </v-col>
          <v-col cols="12" sm="9" md="10">
            <v-text-field
              :label="$t('userinfo_phone_number')"
              v-model="userInfo.mobile"
              disabled
              outlined
              autocomplete="off"
              append-icon="mdi-lock"
              color="primary-1"
            ></v-text-field>
          </v-col>
        </v-row>
        <div>
          <v-row no-gutters>
            <v-col
              cols="12"
              sm="3"
              md="2"
              :class="$vuetify.breakpoint.xs ? 'pr-2' : 'pr-5'"
            >
              <v-subheader
                ><v-icon
                  color="red-2"
                  x-small
                  :class="{ 'mr-1': !$vuetify.breakpoint.xs }"
                  >mdi-asterisk</v-icon
                >{{ $t("userinfo_email") }}</v-subheader
              >
            </v-col>
            <!-- todo 電子郵件 是否進行過 verify ， 有則可修改 -->
            <v-col cols="12" sm="9" md="10" style="position: relative">
              <v-text-field
                id="email"
                :label="$t('userinfo_email')"
                v-model="userInfo.email"
                :disabled="userInfo.verifyEmail"
                :append-icon="userInfo.verifyEmail ? 'mdi-lock' : ''"
                :error="hasInvalid && !!invalidError.email"
                :error-messages="
                  hasInvalid && !!invalidError.email
                    ? [invalidError.email]
                    : null
                "
                @focus="
                  {
                    userInfo.email =
                      userInfo.email.indexOf('*') === -1 ? userInfo.email : '';
                  }
                "
                autocomplete="off"
                @blur="
                  userInfo.email =
                    userInfo.email === '' ? originUserEmail : userInfo.email
                "
                @change="changeEmail"
                outlined
                color="primary-1"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
              <div
                v-if="userInfo.verifyEmail"
                class="font-weight-bold"
                :class="
                  $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                    ? 'mb-15 text-right'
                    : 'send-email-verify'
                "
              >
                <template>
                  <v-icon color="#28bd92" size="20">mdi-check-circle</v-icon>
                  <span style="color: #28bd92">
                    {{ $t("userinfo_email_valid") }}</span
                  >
                </template>
                <v-btn
                  @click="doChangeEmail"
                  v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
                  outlined
                  rounded
                  color="primary-1"
                  style="border: 2px solid"
                  class="font-weight-bold ml-3"
                  ><v-icon class="mr-1">mdi-sync</v-icon>
                  {{ $t("userinfo_change_email_cta") }}</v-btn
                >
              </div>
              <div
                class="v-alert p-4 text-left red--text pink-1 font-weight-regular"
              >
                {{ $t("change_email_note") }}
              </div>
            </v-col>
          </v-row>
        </div>

        <v-row
          no-gutters
          class="mb-15"
          v-if="
            userInfo.verifyEmail &&
            !$vuetify.breakpoint.xs &&
            !$vuetify.breakpoint.sm
          "
        >
          <v-spacer />
          <v-btn
            @click="doChangeEmail"
            outlined
            rounded
            color="primary"
            style="border: 2px solid"
            class="font-weight-bold"
            ><v-icon class="mr-1">mdi-sync</v-icon
            >{{ $t("userinfo_change_email_cta") }}</v-btn
          >
        </v-row>

        <v-row no-gutters>
          <v-col
            cols="12"
            sm="3"
            md="2"
            :class="$vuetify.breakpoint.xs ? 'pr-2' : 'pr-5'"
          >
            <v-subheader
              ><v-icon
                color="red-2"
                x-small
                :class="{ 'mr-1': !$vuetify.breakpoint.xs }"
                >mdi-asterisk</v-icon
              >{{ $t("userinfo_contact_address") }}</v-subheader
            >
          </v-col>
          <v-col cols="12" sm="9" md="10">
            <RegionSelect
              :hasInvalid="hasInvalid"
              :invalidError="invalidError"
              :propsCountry="userInfo.country"
              :propsCounty="userInfo.county"
              :propsDistrict="userInfo.district"
              :propsAddress="userInfo.address"
              :propsPostalCode="userInfo.postalCode"
              v-if="loadingGetUserInfoFinsed"
              @updateAddress="emitUpdateAddress"
            />
          </v-col>
        </v-row>
        <v-row no-gutters v-if="this.disabilityEnable">
          <v-col
            cols="12"
            sm="3"
            md="2"
            :class="$vuetify.breakpoint.xs ? 'pr-2' : 'pr-5'"
          >
            <v-subheader>{{ $t("userinfo_disability_identity") }}</v-subheader>
          </v-col>
          <v-col cols="12" sm="9" md="10" id="disbilityArea">
            <!-- Disability Form -->
            <template v-if="!userInfo.validDate">
              <v-checkbox
                v-model="needDisabilityVerify"
                class="mt-0"
                :disabled="disabilityIdentifyFail"
              >
                <template slot="label">
                  <div
                    class="black--text"
                    v-html="$t('userinfo_disability_identity_label')"
                  ></div>
                </template>
              </v-checkbox>
              <div
                class="v-alert p-4 text-left red--text pink-1 font-weight-regular"
              >
                {{ $t("userinfo_disability_identity_note") }}
              </div>
              <div class="text-right">
                <v-btn
                  @click="identityDisability"
                  outlined
                  rounded
                  color="primary"
                  style="border: 2px solid"
                  class="font-weight-bold"
                  :disabled="!needDisabilityVerify || disabilityIdentifyFail"
                >
                  {{ $t("userinfo_disability_identity_cta") }}
                </v-btn>
              </div>
            </template>
            <template v-else>
              <v-text-field
                :label="$t('disability_expire_at')"
                outlined
                append-icon="mdi-lock"
                disabled
                v-model="userInfo.validDate"
              ></v-text-field>
              <div
                class="v-alert p-4 text-left red--text pink-1 font-weight-regular"
              >
                {{ $t("userinfo_disability_identity_note") }}
              </div>
              <div class="text-right">
                <v-btn
                  @click="identityDisability"
                  outlined
                  rounded
                  color="primary"
                  style="border: 2px solid"
                  class="font-weight-bold"
                >
                  {{ $t("userinfo_disability_identity_cta") }}
                </v-btn>
                <span class="ml-5">
                  <v-icon v-if="!disabilityExpire" color="#28bd92" size="20"
                    >mdi-check-circle</v-icon
                  >
                  <v-icon v-else color="#ff0032" size="20">mdi-alert</v-icon>
                  <span
                    :style="{ color: disabilityExpire ? '#ff0032' : '#28bd92' }"
                  >
                    {{
                      disabilityExpire
                        ? $t("userinfo_disability_expire")
                        : $t("userinfo_disability_valid")
                    }}</span
                  >
                </span>
              </div>
            </template>
          </v-col>
        </v-row>
        <template v-if="disabilityEnable && userInfo.validDate">
          <v-row>
            <v-col
              cols="12"
              sm="3"
              md="2"
              :class="$vuetify.breakpoint.xs ? 'pr-2' : 'pr-5'"
            >
              <v-subheader>{{ $t("userinfo_disability_crip") }}</v-subheader>
            </v-col>
            <v-col cols="12" sm="9" md="10">
              <v-text-field
                :label="$t('userinfo_disability_crip')"
                outlined
                append-icon="mdi-lock"
                disabled
                :value="
                  userInfo.playNeed
                    ? $t('userinfo_disability_iscrip')
                    : $t('userinfo_disability_nocrip')
                "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="3"
              md="2"
              :class="$vuetify.breakpoint.xs ? 'pr-2' : 'pr-5'"
            >
              <v-subheader>{{
                $t("userinfo_disability_wheelchair_need")
              }}</v-subheader>
            </v-col>
            <v-col cols="12" sm="9" md="10">
              <v-radio-group
                v-model="userInfo.wheelchairNeed"
                row
                hide-details
                class="ma-0 pa-0 radioBtns"
              >
                <v-radio
                  :label="$t('order_step_1_yes_cta')"
                  color="primary"
                  :value="true"
                ></v-radio>
                <v-radio
                  :label="$t('no_cta')"
                  color="primary"
                  :value="false"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </template>
        <v-row class="text-center mt-5">
          <v-col cols="8" class="mx-auto">
            <v-btn
              depressed
              block
              x-large
              width="250"
              class="nextBtn mx-auto"
              :class="{
                disabledBtn:
                  (!isRegister && !dataUpdate) || !loadingUpdateFinshed,
              }"
              :disabled="(!isRegister && !dataUpdate) || !loadingUpdateFinshed"
              color="white"
              @click="updateUserInfo"
            >
              <template v-if="!loadingUpdateFinshed">
                <v-progress-circular
                  indeterminate
                  color="white"
                  size="25"
                  width="2"
                ></v-progress-circular>
              </template>
              <template v-else>
                {{
                  userInfo.verifyEmail
                    ? $t("userinfo_save")
                    : $t("userinfo_save_and_verify")
                }}
              </template>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
    <v-spacer></v-spacer>
    <!-- ChangeEmail -->
    <v-overlay :opacity="0.6" v-model="showChangeEmailForm" z-index="11">
      <v-dialog
        v-model="showChangeEmailForm"
        width="90%"
        :persistent="true"
        hide-overlay
      >
        <div class="change-email-form pa-5 white rounded-5">
          <div role="button" class="close" @click="closeEmailDialog">
            &times;
          </div>
          <template v-if="updatedEmail">
            <v-row>
              <v-spacer class="d-none d-sm-block" />
              <v-col cols="12" sm="8" md="6" class="text-center pt-10">
                <v-img
                  src="@/assets/image/images-mail@3x.png"
                  :width="imageWidth"
                  class="mx-auto mb-5"
                ></v-img>
                <div class="text-huge-title font-weight-bold">
                  {{ $t("send_email_title") }}
                </div>
                <div
                  class="mt-5 text-title font-weight-bold"
                  v-html="
                    $t('send_email_content', { mail: email || userInfo.email })
                  "
                ></div>
              </v-col>
              <v-spacer class="d-none d-sm-block" />
            </v-row>
            <v-row>
              <v-spacer class="d-none d-sm-block" />
              <v-col class="pt-6 pb-10" col="12" sm="6" md="4">
                <v-btn
                  :disabled="!reSendFinished"
                  @click="sendVerify"
                  x-large
                  outlined
                  color="primary-1"
                  block
                  depressed
                >
                  <template v-if="!reSendFinished">
                    <v-progress-circular
                      indeterminate
                      color="grey"
                      size="25"
                      width="2"
                    ></v-progress-circular>
                  </template>
                  <template v-else>{{ $t("send_email_try_again") }}</template>
                </v-btn>
              </v-col>
              <v-spacer class="d-none d-sm-block" />
            </v-row>
          </template>
          <template v-else>
            <v-form v-model="isFormValid" autocomplete="off">
              <h3 class="text-center py-5 bg-tranparent-yellow">
                {{ $t("change_email_title") }}
              </h3>
              <v-row class="mt-12">
                <v-spacer class="d-none d-sm-block" />
                <v-col cols="12" sm="8" md="4">
                  <v-text-field
                    type="email"
                    v-model="email"
                    outlined
                    autocomplete="off"
                    :label="$t('change_email_new_email_field')"
                    :rules="[inputRules.required, inputRules.email]"
                    hint="如：email@example.com"
                    color="primary-1"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-text-field>
                  <div
                    class="v-alert p-4 text-left red--text pink-1 font-weight-regular"
                  >
                    {{ $t("change_email_note") }}
                  </div>
                </v-col>
                <v-spacer class="d-none d-sm-block" />
              </v-row>
              <v-row>
                <v-spacer />
                <v-col cols="12" sm="8" md="4" class="mb-sm-10">
                  <v-btn
                    depressed
                    x-large
                    width="250"
                    class="nextBtn mx-auto"
                    :class="{
                      disabledBtn: !isFormValid || !loadingUpdateFinshed,
                    }"
                    :disabled="!isFormValid || !loadingUpdateFinshed"
                    color="white"
                    block
                    @click="updateEmail"
                  >
                    <template v-if="!loadingUpdateFinshed">
                      <v-progress-circular
                        indeterminate
                        color="white"
                        size="25"
                        width="2"
                      ></v-progress-circular>
                    </template>
                    <template v-else>
                      {{ $t("change_email_cta") }}
                    </template>
                  </v-btn>
                </v-col>
                <v-spacer />
              </v-row>
            </v-form>
          </template>
        </div>
      </v-dialog>
    </v-overlay>

    <!-- Disabled Identiy -->
    <v-overlay :opacity="0.6" v-model="isDisabilityIdentiy" z-index="11">
      <v-dialog
        v-model="isDisabilityIdentiy"
        width="90%"
        :persistent="true"
        hide-overlay
      >
        <div class="change-email-form pa-5 white rounded-5">
          <div role="button" class="close" @click="closeIdentityDialog">
            &times;
          </div>
          <v-form v-model="isIdentityFormValid">
            <h3 class="text-center py-5 bg-tranparent-yellow">
              {{ $t("disability_identity_form_id_number_title") }}
            </h3>
            <v-row class="mt-12">
              <v-spacer />
              <v-col cols="12" sm="8" md="4">
                <v-text-field
                  color="primary"
                  outlined
                  :label="$t('disability_identity_form_id_number_placeholder')"
                  :rules="[inputRules.required, inputRules.idNumberValid]"
                  v-model="disabilityModalForm.id_number"
                  required
                >
                  <template #message="{ message }">
                    {{ $t(message) }}
                  </template>
                </v-text-field>
              </v-col>
              <v-spacer />
            </v-row>
            <v-row>
              <v-spacer />
              <v-col cols="12" sm="8" md="4" class="mb-sm-10">
                <v-btn
                  depressed
                  x-large
                  width="250"
                  class="nextBtn mx-auto"
                  :class="{
                    disabledBtn:
                      !isIdentityFormValid || !loadingIdentityFinshed,
                  }"
                  :disabled="!isIdentityFormValid || !loadingIdentityFinshed"
                  color="white"
                  block
                  @click="submitDisabilityIdNumber"
                >
                  <template v-if="!loadingUpdateFinshed">
                    <v-progress-circular
                      indeterminate
                      color="white"
                      size="25"
                      width="2"
                    ></v-progress-circular>
                  </template>
                  <template v-else>
                    {{ $t("disability_identity_form_id_number_submit") }}
                  </template>
                </v-btn>
              </v-col>
              <v-spacer />
            </v-row>
          </v-form>
        </div>
      </v-dialog>
    </v-overlay>
  </v-row>
</template>

<script>
import UM from "@/api/user-management";
import DatePicker from "./DatePicker.vue";
import RegionSelect from "./RegionSelect.vue";
import inputRulesJS from "@/shared/inputRules.js";
import { mapActions, mapGetters } from "vuex";
import jwt_decode from "jwt-decode";
import { decrypt as AESdecrypt } from "../../../vendor/AEScrypto";

import _ from "lodash";

const disabilityEnable =
  process.env["VUE_APP_DISABILITY_ENABLE"] === true ||
  process.env["VUE_APP_DISABILITY_ENABLE"] === "true";

export default {
  components: { DatePicker, RegionSelect },
  props: {
    isRegister: {
      type: Boolean,
      default: false,
    },
    registerEmail: {
      type: String,
      default: "",
    },
    propsEditMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editMode: this.propsEditMode,
      isSubmitted: false,
      decodeInfo: "",
      disabilityEnable: disabilityEnable,
      originUserName: "",
      originUserEmail: "",
      invalidError: {},
      userInfo: {
        userName: "",
        birthday: "",
        gender: "",
        mobile: "", // 手機號碼
        email: "", // 電郵地址
        postalCode: "",
        country: "",
        county: "",
        district: "",
        address: "",
        verifyEmail: null,
      },
      reSendFinished: true,
      isFormValid: false,
      email: "",
      inputRules: {
        required: inputRulesJS.required,
        email: inputRulesJS.email,
        idNumberValid: inputRulesJS.idNumberValid,
      },
      loadingUpdateFinshed: true,
      maskedUserInfo: {},
      updatedEmail: false,
      showChangeEmailForm: false,
      loadingGetUserInfoFinsed: false,
      isDisabilityIdentiy: false,
      isIdentityFormValid: false,
      loadingIdentityFinshed: true,
      needDisabilityVerify: false,
      disabilityIdentifyFail: false,
      disabilityForm: {},
      disabilityModalForm: {
        id_number: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      accessToken: "user/access_token",
    }),
    userBirthYear() {
      return this.userInfo.birthday?.split("-")[0];
    },
    disabilityExpire() {
      if (!this.userInfo.validDate) return false;
      let dt = new Date().valueOf();
      let validDt = new Date(this.userInfo.validDate).valueOf();

      return validDt < dt;
    },
    hasInvalid() {
      return Object.keys(this.invalidError).length > 0;
    },
    formRequired() {
      let valid = true;
      const key = [
        "userName",
        "email",
        "postalCode",
        "country",
        "county",
        "district",
        "address",
      ];

      for (var i in key) {
        let k = key[i];
        let item = this.userInfo[k];
        if (!item || item === "" || !/^(?!\s*$).+/.test(item)) {
          this.invalidError[k] = "field_required";
          return false;
        } else if (k === "email" && !/.+@.+\..+/.test(item)) {
          valid = false;
          this.invalidError[k] = "email_format_error";
          return false;
        }
      }

      return valid;
    },
    imageWidth() {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm)
        return "100";
      else return "120";
    },
    dataUpdate() {
      let update = false;
      if (this.disabilityEnable) {
        for (var i in this.disabilityForm) {
          if (this.disabilityForm[i] !== this.userInfo[i]) update = true;
        }
      }
      for (var i in this.maskedUserInfo) {
        if (this.maskedUserInfo[i] !== this.userInfo[i]) update = true;
      }
      if (update) this.isSubmitted = false;
      return update;
    },
  },
  watch: {
    accessToken(val, old) {
      if (val !== old && val !== "") {
        this.getUserInfo();
      }
    },
    editMode(val) {
      if (!val) {
        this.getUserInfo();
      }
    },
  },
  async mounted() {
    await this.getUserInfo();

    if (this.$route.params.needDisbilityVerify) {
      this.editMode = true;
      this.$forceUpdate();
      setTimeout(() => {
        window.scrollTo({
          left: 0,
          top: document.querySelector("#disbilityArea").offsetTop,
          behavior: "smooth",
        });
      }, 200);
    }
    this.$store.dispatch("setOverlayLoading", false);
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
      setLogin: "user/login",
      setLogout: "user/logout",
      setLogoutToIndex: "user/logoutToIndex",
      refreshToken: "user/refreshToken",
      logout: "user/logoutToIndex",
      storeRegisterEmail: "register/setRegisterEmail",
    }),
    changeEmail() {
      if (!this.isRegister) return;
      this.storeRegisterEmail(this.userInfo.email);
    },
    async submitDisabilityIdNumber() {
      this.loadingIdentityFinshed = false;
      const { data } = await UM.createDisability({
        idNo: this.disabilityModalForm.id_number,
        wheelchairNeed: false,
      });

      if (data.errCode === "00" && data.item && data.item.isCrip) {
        this.isDisabilityIdentiy = false;
        let dt = new Date().valueOf();
        let validDt = data.item.validDate
          ? new Date(data.item.validDate).valueOf()
          : null;
        this.disabilityForm = {
          validDate: data.item.validDate,
          isCrip: data.item.isCrip,
          playNeed: data.item.playNeed,
          wheelchairNeed: data.item.wheelchairNeed,
        };
        this.userInfo = {
          ...this.userInfo,
          ...this.disabilityForm,
        };

        if (validDt && validDt > dt) {
          this.showDialog({
            error: true,
            title: this.$t("validation_email_title"),
            content: this.$t("id_number_identity_success"),
            buttons: this.$t("order_step_1_reserve_dialog_cta"),
            action: () => {
              this.logout();
            },
          });
        } else {
          this.showDialog({
            error: true,
            title: this.$t("validation_email_title"),
            content: this.$t("id_number_identity_expired"),
            button: this.$t("order_step_1_reserve_dialog_cta"),
          });
          this.isDisabilityIdentiy = false;
          this.disabilityIdentifyFail = true;
        }
      } else {
        if (data.errCode === "134") {
          this.showDialog({
            error: true,
            title: this.$t("reset_pwd_verify_fail_title"),
            content: "綁定失敗！身分證字號已綁定於其他帳號。",
            button: this.$t("order_step_1_reserve_dialog_cta"),
          });
        } else {
          this.showDialog({
            error: true,
            title: this.$t("reset_pwd_verify_fail_title"),
            content: this.$t("id_number_identity_fail"),
            button: this.$t("order_step_1_reserve_dialog_cta"),
          });
        }
        this.isDisabilityIdentiy = false;
        this.disabilityIdentifyFail = true;
      }
      this.loadingIdentityFinshed = true;
    },
    identityDisability() {
      this.isDisabilityIdentiy = true;
    },
    closeIdentityDialog() {
      document.body.classList.remove("dialog-open");
      this.isDisabilityIdentiy = false;
    },
    async sendVerify() {
      this.reSendFinished = false;
      const { data } = await UM.sendEmailVerify();
      if (data.errCode !== "00") {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
              <img
                src="/image/ic-warning@3x.png"
                alt=""
                style="width:80px"
              />
              <div class="mt-5">${this.$t("send_email_submit_fail")}<br>${
            data.errDetail
          }</div>
            </div>`,
        });
        // (console.log
        //   `發送失敗\nerrCode: ${data.errCode}\nerrMsg: ${data.errMsg}\nerrDetail: ${data.errDetail}`
        // );
      } else {
        if (!this.showChangeEmailForm) {
          this.updatedEmail = true;
          this.showChangeEmailForm = true;
        }
      }
      this.reSendFinished = true;
    },
    async updateEmail() {
      this.loadingUpdateFinshed = false;
      const { data } = await UM.updateUserInfo({ email: this.email });
      if (data.errCode == "00") {
        this.updatedEmail = true;
      }
      if (data.errCode !== "00") {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t(
              data.errCode === "146"
                ? "input_email"
                : "change_email_submit_fail"
            )}</div>
          </div>`,
        });
      }
      this.loadingUpdateFinshed = true;
    },
    closeEmailDialog() {
      document.body.classList.remove("dialog-open");
      this.showChangeEmailForm = false;
      if (this.updatedEmail) this.setLogoutToIndex();
    },
    doChangeEmail() {
      document.body.classList.add("dialog-open");
      this.showChangeEmailForm = true;
      // this.$router.push({ name: 'ChangeEmail' }).catch(()=>{})
    },
    genderText(gender) {
      if (gender === "M") return "男";
      if (gender === "F") return "女";
      if (gender === "N") return "其他";
      return "-";
    },

    emitUpdateDate(date) {
      this.userInfo.birthday = date;
    },

    emitUpdateAddress(address) {
      this.userInfo.country = address.country;
      this.userInfo.county = address.county;
      this.userInfo.district = address.district;
      this.userInfo.address = address.address;
      this.userInfo.postalCode = address.postalCode;
    },

    edit() {
      this.editMode = true;
      this.maskedUserInfo = _.clone(this.userInfo);
      let addressArray = this.decodeInfo.split(",");
      addressArray.reverse();
      if (addressArray[0].indexOf("***") > -1) {
        this.userInfo.address = "";
      }
    },

    async getUserInfo() {
      this.loadingGetUserInfoFinsed = false;
      if (this.isRegister) this.userInfo.email = this.registerEmail;
      else {
        const user = JSON.parse(Cookies.get("user"));
        const token = jwt_decode(user.access_token);

        const {
          maskedUserName,
          maskedMobile,
          maskedEmail,
          maskedBirthday,
          country,
          gender,
          disability,
        } = token;

        this.originUserName = maskedUserName;
        this.originUserEmail = maskedEmail;
        this.userInfo.userName = maskedUserName || "";
        this.userInfo.birthday = maskedBirthday || "";
        this.userInfo.mobile = maskedMobile;
        this.userInfo.email = maskedEmail;

        this.userInfo = {
          ...this.userInfo,
          ...disability,
        };
        this.disabilityForm = {
          ...disability,
        };
        this.needDisabilityVerify = disability && !!disability.validDate;

        if (token.encryptedAddress && token.encryptedAddress.encryptedData) {
          this.decodeInfo = AESdecrypt(
            token.encryptedAddress.encryptedData,
            token.encryptedAddress.iv
          );
          let addressArray = this.decodeInfo ? this.decodeInfo.split(",") : [];

          if (!country || country === "Taiwan") {
            [
              this.userInfo.postalCode,
              this.userInfo.county,
              this.userInfo.district,
              this.userInfo.address,
            ] = addressArray;
          } else {
            [
              this.userInfo.address,
              this.userInfo.county,
              this.userInfo.district,
              this.userInfo.postalCode,
            ] = addressArray;
          }
        }
        this.userInfo.country = country || "";
        this.userInfo.gender = gender;
        this.userInfo.verifyEmail = user.verifyEmail;
        this.loadingGetUserInfoFinsed = true;
      }
      this.loadingGetUserInfoFinsed = true;
    },

    compareUpdateInfo(option) {
      if (this.maskedUserInfo[option] !== this.userInfo[option]) return true;
    },

    gotoFormField() {
      for (let i in this.invalidError) {
        let elem = document.getElementById(i);
        const rect = elem.parentNode.getBoundingClientRect();
        if (elem) {
          window.scrollTo({
            left: 0,
            top: window.scrollY + rect.top - 100,
            behavior: "smooth",
          });

          return false;
        }
      }
    },

    async updateUserInfo() {
      this.invalidError = {};
      this.loadingUpdateFinshed = false;
      let updateData = {};

      if (!this.formRequired) {
        this.gotoFormField();
        this.loadingUpdateFinshed = true;
        return;
      }
      if (this.compareUpdateInfo("userName"))
        updateData.userName = this.userInfo.userName;
      if (
        this.compareUpdateInfo("postalCode") ||
        this.compareUpdateInfo("county") ||
        this.compareUpdateInfo("district") ||
        this.compareUpdateInfo("address")
      )
        updateData.address =
          this.userInfo.country === "Taiwan"
            ? `${this.userInfo.postalCode},${this.userInfo.county},${this.userInfo.district},${this.userInfo.address}`
            : `${this.userInfo.address},${this.userInfo.county},${this.userInfo.district},${this.userInfo.postalCode}`;
      if (this.compareUpdateInfo("country"))
        updateData.country = this.userInfo.country;
      if (this.compareUpdateInfo("birthday"))
        updateData.birthday = this.userInfo.birthday;
      if (this.compareUpdateInfo("gender"))
        updateData.gender = this.userInfo.gender;
      if (!this.userInfo.verifyEmail && this.compareUpdateInfo("email"))
        updateData.email = this.userInfo.email;
      if (this.compareUpdateInfo("wheelchairNeed")) {
        updateData.wheelchairNeed = this.userInfo.wheelchairNeed;
      }
      // console.log(`${String.fromCodePoint(128049)} update data:`, updateData);
      const { data: updateUserInfoRes } = await UM.updateUserInfo(updateData);
      // console.log(
      //   `${String.fromCodePoint(128049)} [UM] updateUserInfo`,
      //   updateUserInfoRes
      // );
      if (updateUserInfoRes.errCode === "00") {
        if (this.userInfo.verifyEmail) {
          this.showDialog({
            alert: true,
            content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-success@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t("userinfo_submit_success")}</div>
          </div>`,
          });
          this.editMode = false;
          this.$router.push({
            name: "Index",
          });
        } else {
          if (this.isRegister) this.$emit("nextStep");
          else
            this.$router
              .push({
                name: "HasSendEmail",
                params: { email: this.userInfo.email },
              })
              .catch(() => {});
          this.loadingUpdateFinshed = true;
        }
      } else {
        const errMsg =
          updateUserInfoRes.errCode === "146"
            ? this.$t("input_email")
            : updateUserInfoRes.errDetail;
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t(
              "userinfo_submit_fail"
            )}<br>${errMsg}</div>
          </div>`,
        });
        console.log(
          `修改失敗\nerrCode: ${updateUserInfoRes.errCode}\nerrMsg: ${errMsg}\nerrDetail: ${updateUserInfoRes.errDetail}`
        );

        if (this.$route.name === "register") {
          setTimeout(() => {
            this.$router.push({ name: "Index" }).catch(() => {});
          }, 2000);
        }
      }
      this.loadingUpdateFinshed = true;

      const { data: refreshInfo } = await UM.refreshToken();
      if (refreshInfo.errCode == "00") {
        await this.refreshToken(refreshInfo.userInfo);
        this.getUserInfo();
      } else {
        console.error("[TOKEN] Refresh Failed", refreshInfo);
        this.setLogout();
        this.$router.push({
          name: "Index",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-subheader {
  padding: 0;
  float: right;
  font-weight: bold;
  color: black;

  @media screen and (max-width: 600px) {
    float: left;
  }
}

::v-deep {
  .radioBtns .v-messages {
    display: none;
  }

  .v-input--radio-group {
    .v-input__slot {
      margin: 0;
    }
  }

  .v-messages {
    display: none;

    &.error--text {
      display: unset;
    }
  }

  .v-dialog {
    overflow: visible;
  }

  .v-dialog__content {
    > .v-dialog {
      overflow: visible !important;

      .change-email-form {
        position: relative;
      }
    }
  }
}

.v-dialog__content {
  .v-dialog {
    overflow: visible !important;
  }

  .change-email-form {
    position: relative;
  }

  .close {
    position: absolute;
    font-size: 32px;
    width: 48px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    color: white;
    right: -48px;
    top: 0;

    @media screen and (max-width: 600px) {
      right: 0;
      top: -48px;
    }
  }
}

.send-email-verify {
  position: absolute;
  top: 14px;
  left: 103%;
  white-space: nowrap;
}
</style>
